<template>
  <keep-alive include="home">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
  import DevicePixelRatio from '@/utils/DevicePixelRatio.js';
  import Vue from "vue";
  import $ from "jquery";
  import {
    gitajax
  } from "@/api/jqajax";
  export default {
    name: 'App',
    mounted() {
      // new DevicePixelRatio().init();

      $(document).on("click", (ev) => {
        var layvue = this.getVue('layoutvue');
        if (layvue) {
          layvue.$emit('closedropdown', ev);
        }
      });
  
      // document.addEventListener('wheel', this.preventZoom, { passive: false });

    },
    methods:{
      preventZoom(event) {
            if (event.metaKey) {

              event.preventDefault();
            }
          }
    },
    watch: {

    }

  }
</script>
<style lang="scss">
  //[pagescrollbar] {
  //  height: 100%;
  //}
  //
  //.el-scrollbar[pagescrollbar] .el-scrollbar__bar.is-vertical {
  //  opacity: 0;
  //}
</style>



// WEBPACK FOOTER //
// src/App.vue